export enum FORM_TYPES {
  'EARLY_ACCESS' = 'EARLY_ACCESS',
  'SUBSCRIBE' = 'SUBSCRIBE'
}
